import { createSlice } from "@reduxjs/toolkit";
import {
  getTransmission,
} from "./transmissionService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  transmissionList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const transmissionSlice = createSlice({
  name: "transmission",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Transmission List ---------- */
    builder
      .addCase(getTransmission.pending, (state) => {
        state.transmissionList.status = STATUS.LOADING;
        state.transmissionList.error = null;
      })
      .addCase(getTransmission.fulfilled, (state, action) => {
        state.transmissionList.status = STATUS.SUCCEEDED;
        state.transmissionList.data = action?.payload?.data || [];
      })
      .addCase(getTransmission.rejected, (state, action) => {
        state.transmissionList.status = STATUS.FAILED;
        state.transmissionList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectTransmissionList = (state) =>
  state.transmission.transmissionList;

export default transmissionSlice.reducer;
